export default "__VITE_ASSET__cf16a470__"